import api from '../utils/request';
import { extractErrorMessage } from '../utils/apiErrorHandler';

class InviteCodeAPI {
  async validateInviteCode(inviteCode) {
    try {
      const response = await api.post('/invite-code/validate', {
        invite_code: inviteCode
      });
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error) || '邀请码验证失败，请稍后重试');
    }
  }
}

const inviteCodeApi = new InviteCodeAPI();
export default inviteCodeApi; 
